import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "go-app/components/Header";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { PurchaseContext } from "../../../../pages/Preview";
import PurchaseCorrectionForm from "../../components/Form/PurchaseCorrectionForm";

const OrganizationOrderPurchaseCorrectionNewPage = () => {
	const { purchaseCorrectionCustomFieldsConfig, purchase } = useContext(PurchaseContext);
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(
			`${purchase.document_number} | ${t("modules.purchase.header.title")} | ${t(
				"modules.purchase.field.new_correction.title"
			)}`
		);
	}, []);

	if (!purchaseCorrectionCustomFieldsConfig) return <LoadingContainer />;

	return (
		<div className="mt-4">
			<Header title={t("modules.purchase.field.new_correction.title")} />
			<PurchaseCorrectionForm purchaseCorrectionCustomFieldsConfig={purchaseCorrectionCustomFieldsConfig} />
		</div>
	);
};

export default OrganizationOrderPurchaseCorrectionNewPage;
